import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    
  }

  render() {
    if (this.state.hasError) {
      // Render fallback UI when an error occurs.
      return (
        <div>
          <h2>Oops! Something went wrong.</h2>
          <p>Please try again later.</p>
        </div>
      );
    }

    // Render the children components when there are no errors.
    return this.props.children;
  }
}

export default ErrorBoundary;